import { goto } from "$app/navigation";
import type { Notification } from "#lib/api-client/types.gen.js";

/** Action URLs the UI is willing to navigate to from a notification. */
const VALID_ROUTE_PREFIXES = ["/case-files/", "/imports", "/exports", "/users", "/dashboard"];

/**
 * Reports whether a notification's action URL is a known in-app route. The URL
 * comes from the backend, but validating it keeps a bad row from turning into an
 * open redirect.
 */
export function isSafeActionUrl(url: string | null | undefined): boolean {
	if (!url || !url.startsWith("/")) return false;
	return VALID_ROUTE_PREFIXES.some(
		(prefix) => url === prefix.replace(/\/$/, "") || url.startsWith(prefix),
	);
}

/** The button label for a notification that links somewhere. */
function actionLabel(notification: Notification): string {
	const caseFileID = notification.metadata?.case_file_id;
	return caseFileID ? "Open case file" : "Open";
}

/** Builds the toast action for a notification, or undefined when there is none. */
export function notificationAction(
	notification: Notification,
): { label: string; onClick: () => void } | undefined {
	if (!isSafeActionUrl(notification.action_url)) return undefined;
	const url = notification.action_url as string;
	return {
		label: actionLabel(notification),
		onClick: () => {
			void goto(url);
		},
	};
}
